import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "@/assets/fonts/vfs_fonts.js"
import { csvParse } from "d3"

pdfMake.fonts = {
  NotoSansTC: {
    normal: "NotoSansTC-Regular.otf",
    bold: "NotoSansTC-Bold.otf"
  }
}

var docDefinitionTemplate = {
  pageOrientation: "portrait", //landscape
  info: {
    title: "awesome Document"
  },
  content: [],
  styles: {
    title: {
      fontSize: 20,
      alignment: "center",
      bold: true,
      margin: [0, 0, 0, 20]
    },
    header: {
      fontSize: 18,
      bold: true,
      margin: [0, 0, 0, 10]
    },
    subheader: {
      fontSize: 16,
      bold: true,
      margin: [0, 10, 0, 5]
    },
    tableExample: {
      margin: [0, 5, 0, 15]
    },
    tableHeader: {
      bold: true,
      // fontSize: 13,
      color: "black"
    },
    boldText: {
      bold: true
    }
  },
  defaultStyle: {
    font: "NotoSansTC"
  }
}

function pdfTitle(title, pageBreakTag = false) {
  var object = { text: title, style: "title" }
  if (pageBreakTag) object.pageBreak = "before"
  return object
}

function pdfHeader(headerText, pageBreakTag = false) {
  var object = { text: headerText, style: "header" }
  if (pageBreakTag) object.pageBreak = "before"
  return object
}

function pdfTableHeader(headerText, colSpan = 1, alignment = "left", border = [true, true, true, true]) {
  var object = { text: headerText, style: "tableHeader", colSpan: colSpan, alignment: alignment, border: border }
  return object
}

function pdfTableText(text, colSpan = 1, alignment = "left", border = [true, true, true, true]) {
  return { text: text, colSpan: colSpan, alignment: alignment, border: border }
}

function pdfTableBoldText(text, colSpan = 1, alignment = "left", border = [true, true, true, true]) {
  return {
    text: text,
    colSpan: colSpan,
    alignment: alignment,
    style: "boldText",
    border: border
  }
}

function pdfBoldText(text) {
  return { text: text, style: "boldText" }
}

function pdfTableSimple(body) {
  var colsize = body[0].length
  return {
    style: "tableExample",
    table: {
      widths: Array(colsize).fill("*"),
      body: body
    }
  }
}

function pdfTableSimpleWithWidths(body, widths) {
  return {
    style: "tableExample",
    table: {
      widths: widths,
      body: body
    }
  }
}

function getDocDefinition(content) {
  docDefinitionTemplate.content = content
  return docDefinitionTemplate
}

async function downloadPDF(fileName, content, pageOrientation = "portrait") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs

  docDefinitionTemplate.content = content
  docDefinitionTemplate.info.title = fileName
  docDefinitionTemplate.pageOrientation = pageOrientation
  pdfMake.createPdf(docDefinitionTemplate).download(fileName)
}

export {
  pdfTitle,
  pdfHeader,
  pdfTableHeader,
  pdfTableSimple,
  pdfTableText,
  pdfTableBoldText,
  pdfTableSimpleWithWidths,
  pdfBoldText,
  downloadPDF
}
